import STORAGETYPE from "./storage_types";

export const submit_map_details = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.MAP_DETAILS,
    payload: formData,
  });
};

export const submit_restaurant_details = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.RESTAURANT_DETAILS,
    payload: formData,
  });
};

export const submit_point_of_contact = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.POINT_OF_CONTACT,
    payload: formData,
  });
};

export const submit_chain_setting = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.CHAIN_SETTING,
    payload: formData,
  });
};

export const submit_restaurant_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.RESTAURANT_TYPE,
    payload: formData,
  });
};

export const submit_payment_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.PAYMENT_TYPE,
    payload: formData,
  });
};

export const submit_dress_code = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.DRESS_CODE,
    payload: formData,
  });
};

export const submit_pets_allowed = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.PETS_ALLOWED,
    payload: formData,
  });
};

export const submit_located_inside = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.LOCATED_INSIDE,
    payload: formData,
  });
};

export const submit_point_of_sale = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.POINT_OF_SALE,
    payload: formData,
  });
};

export const submit_health_and_senitation = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.HEALTH_AND_SENITATION,
    payload: formData,
  });
};

export const submit_parking_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.PARKING_TYPE,
    payload: formData,
  });
};

export const submit_accessibility_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.ACCESSIBILITY,
    payload: formData,
  });
};

export const submit_other_features_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.OTHER_FEATURES,
    payload: formData,
  });
};

export const submit_services_offered_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.SERVICES_OFFERED,
    payload: formData,
  });
};

export const submit_cuisine_features_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.CUISINE_FEATURES,
    payload: formData,
  });
};

export const submit_food_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.FOOD_TYPE,
    payload: formData,
  });
};

export const submit_cuisine_offered_type = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.CUISINE_OFFERED,
    payload: formData,
  });
};

export const submit_business_hours = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.BUSINESS_HOURS,
    payload: formData,
  });
};

export const submit_kyc_details = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.KYC_DETAILS,
    payload: formData,
  });
};

export const submit_subscription_details = (formData) => (dispatch) => {
  dispatch({
    type: STORAGETYPE.SUBSCRIPTION_DETAILS,
    payload: formData,
  });
};
